const FOOTER_LINKS = {
  main: [
    { label: '首页', href: '#hero' },
    { label: '平台介绍', href: '#about' },
    { label: '影视索引', href: '#index' },
    { label: '热播剧集', href: '#media' },
    { label: '焦点专题', href: '#carousel' },
    { label: '热度排行', href: '#ranking' },
  ],
  resource: [
    { label: '香蕉视频资源', href: '#index' },
    { label: '糖豆视频资源', href: '#index' },
    { label: '小蓝视频资源', href: '#index' },
    { label: '蓝莓视频资源', href: '#index' },
    { label: '电影大全', href: '#media' },
    { label: '电视剧全集', href: '#media' },
  ],
  help: [
    { label: '常见问题', href: '#faq' },
    { label: '联系我们', href: '#contact' },
    { label: '移动观影', href: '#app' },
    { label: '最新动态', href: '#updates' },
    { label: '优势特色', href: '#features' },
    { label: '使用指南', href: '#faq' },
  ],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-100">
      <div className="py-14 md:py-20 px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="text-xl font-heading text-background-50 mb-3 block">玫瑰视频</span>
              <p className="text-sm text-background-100/60 leading-relaxed">
                汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源，
                高清免费在线观看不缓冲，海量电视剧全集和电影大全每日更新，满足各类追剧需求。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {FOOTER_LINKS.main.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-100/60 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">影视资源</h4>
              <ul className="space-y-2.5">
                {FOOTER_LINKS.resource.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-100/60 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">帮助中心</h4>
              <ul className="space-y-2.5">
                {FOOTER_LINKS.help.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-sm text-background-100/60 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-background-100/40 flex-wrap">
              <span>玫瑰视频</span>
              <span className="hidden sm:inline">·</span>
              <span>高清免费在线观看不缓冲</span>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-100/40">合作伙伴</span>
            </div>
            <div className="text-xs text-background-100/40">
              <span>声明：本站资源仅供交流学习，版权归原作者所有</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}